import ReportsNavigation from './ReportsNavigation'
export default ReportsNavigation
